import React from 'react';
import PropTypes from 'prop-types';

import { Table } from 'react-bootstrap';

import { connect } from 'react-redux';

import Row from './row';

export function Users({ users }) {
  const orderedUsers = [...users.filter(user => !user.disabled), ...users.filter(user => user.disabled)];
  return (
    <div className="backoffice-settings-table-wrapper">
      <Table className="commission-plans-index__users-table" responsive>
        <thead>
          <tr>
            <th>Broker Name</th>
            <th>Assigned To</th>
            <th className="primary-plan-column">Default Plan</th>
          </tr>
        </thead>
        <tbody>
          {orderedUsers.map(user => <Row key={user.id} user={user} />)}
        </tbody>
      </Table>
    </div>
  );
}

Users.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
  })).isRequired,
};

const mapStateToProps = state => ({
  users: state.users,
});

export default connect(mapStateToProps)(Users);
